// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"5537ddaa","606":"cfe73988","703":"72e070ec"}[chunkId] + ".chunk.js";
};